import React, { Fragment } from 'react'
import classNames from 'classnames'
import { CircleNotchIcon } from '@phosphor-icons/react';

export default function LoadingOverlay({
    isLoading,
    className = ""
}) {

    let classes = typeof className === "string" ? className.split(" ").reduce((acc, item) => {
        acc[item] = true
        return acc
    }, {}) : className;

    const Classes = classNames({
        'fixed top-0 left-0 right-0 bottom-0 bg-black/90 z-[var(--z-loading)] flex items-center justify-center': true,
        ...classes
    })

    if(isLoading) {
        return (
            <div className={Classes}>
                <CircleNotchIcon size={44} className="fill-white animate-spin mb-2" weight="bold" />
            </div>
        )
    }

    return (
        <Fragment />
    )
}
